/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { useState } from 'react';
// useState

// import PropTypes from 'prop-types';

import {
  Select,
  Form,
  Checkbox,
  Radio,
  Input,
  Button,
  // DatePicker
} from 'antd';
// import moment from 'moment';
// import NumberFormat from 'react-number-format';

// import {
//   DownloadOutlined,
//   RightOutlined,
//   LeftOutlined,
// } from '@ant-design/icons';

// import

import * as companyOptions from '../optionsJson/company';

const { Option } = Select;

const Header = block => {
  const { data } = block;
  console.log(data);
  const [sdb, setsdb] = useState(!!data.values.sdbEthnicType);

  const [vosb, setvosb] = useState(!!data.values.vosb);
  const [wosb, setwosb] = useState(!!data.values.wosb);

  console.log(sdb, !!data.values.sdbEthnicType);
  // eslint-disable-next-line no-unused-vars
  const createOptions = obj => {
    if (!obj) {
      return '';
    }
    const objKeys = Object.keys(obj);

    const options = objKeys.map(key => {
      const text = obj[key];
      const value = key;
      return <Option value={value}>{text}</Option>;
    });
    return options;
  };

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">Company</div>
      <Form layout="vertical">
        <Form.Item
          label={
            <p style={{ fontWeight: 800, margin: 0 }}>
              Small Business and Other Business Type Representations:
            </p>
          }
        >
          <Select
            allowClear
            onChange={value => {
              data.changeValues('sbReps', value);
            }}
            value={data.values.sbReps}
            placeholder="--Select--"
          >
            {createOptions(companyOptions.businessType)}
          </Select>
        </Form.Item>

        {(data.values.sbReps === 'M' || data.values.sbReps === 'B') && (
          <Form.Item>
            <div
              className="vertical"
              // onChange={onChange}
            >
              {' '}
              <Checkbox
                onChange={e => {
                  setsdb(e.target.checked);
                }}
                checked={sdb}
              >
                Small Disadvantaged Business
              </Checkbox>
              {sdb && (
                <Select
                  allowClear
                  placeholder="---Select SDB Designated Group--"
                  onChange={value => {
                    data.changeValues('sdbEthnicType', value);
                  }}
                  value={data.values.sdbEthnicType}
                >
                  {createOptions(companyOptions.disadvantagedBusiness)}
                </Select>
              )}
              <Checkbox
                onChange={e => {
                  setwosb(e.target.checked);
                }}
                checked={wosb}
              >
                Woman Owned Business
              </Checkbox>
              {wosb && (
                <Select
                  allowClear
                  placeholder="---Select WOSB Designated Group--"
                  onChange={value => {
                    data.changeValues('wosb', value);
                  }}
                  value={data.values.wosb}
                >
                  {createOptions(companyOptions.womanOwned)}
                </Select>
              )}
              <Checkbox
                onChange={e => {
                  setvosb(e.target.checked);
                }}
                checked={vosb}
              >
                Veteran Owned Small Business
              </Checkbox>
              {vosb && (
                <Select
                  value={data.values.vosb}
                  allowClear
                  placeholder="---Select VOSD Designated Group--"
                  onChange={value => {
                    data.changeValues('vosb', value);
                  }}
                >
                  {createOptions(companyOptions.vetranOwned)}
                </Select>
              )}
              <Checkbox
                onChange={e => {
                  data.changeValues('hubzoneSb', e.target.checked);
                }}
                checked={data.values.hubzoneSb}
              >
                hubZone Small Business
              </Checkbox>
              {data.values.hubzoneSb && (
                <div>
                  <Checkbox
                    // TODO: set this up to values
                    onChange={e => {
                      data.changeValues('hubzoneJv', e.target.checked);
                    }}
                    checked={data.values.hubzoneJv}
                  >
                    hubZone Joint Venture that cimplies with 13 CFR Part 26
                  </Checkbox>
                  <p>
                    enter CAGE(s)/Name(s) of the participating HUBZone small
                    business concern(s)
                  </p>
                  <Input
                    value={data.values.hubzoneJvRemarks}
                    onChange={e => {
                      data.changeValues('hubzoneJvRemarks', e.target.value);
                    }}
                  />
                </div>
              )}
            </div>
          </Form.Item>
        )}

        <Form.Item
          label={
            <p style={{ fontWeight: 800, margin: 0 }}>
              Affirmative Action Compliance:
            </p>
          }
        >
          <Select
            allowClear
            placeholder="---Select--"
            onChange={value => {
              data.changeValues('affrmActComp', value);
            }}
            value={data.values.affrmActComp}
          >
            {createOptions(companyOptions.affirmativeActionCompliance)}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <p style={{ fontWeight: 800, margin: 0 }}>
              Previous Contracts & Compliance Reports:
            </p>
          }
        >
          <Select
            allowClear
            placeholder="---Select--"
            onChange={value => {
              data.changeValues('prevContCompRepo', value);
            }}
            value={data.values.prevContCompRepo}
          >
            {createOptions(companyOptions.previousContract)}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <p style={{ fontWeight: 800, margin: 0 }}>
              Alternate Dispute Resolution
            </p>
          }
        >
          <p>
            do you agree to use alternate dispute resolution in accordance with
            DLAD 52.233-9001
          </p>
          <Radio.Group
            onChange={e => {
              data.changeValues('altDesptRes', e.target.value);
            }}
            value={data.values.altDesptRes}
          >
            {' '}
            <Radio value="A">Yes</Radio>
            <Radio value="B">No</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
      <div className="wizard-button-wrapper">
        <Button>Previous</Button>
        <Button type="primary">Next</Button>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/subcomponents/DibbsCompany.jsx